import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { API_BASE } from '../config';

export const ProjectRedirect: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const navigate = useNavigate();
  const { token } = useAuth();

  useEffect(() => {
    const redirectToMainDocument = async (): Promise<void> => {
      if (!token || !projectId || projectId === 'new') {
        return;
      }

      try {
        const response = await fetch(`${API_BASE}/api/projects/${projectId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          if (data.mainDocumentId) {
            navigate(`/projects/${projectId}/documents/${data.mainDocumentId}`, { replace: true });
          } else {
            navigate(`/projects/${projectId}/documents`, { replace: true });
          }
        } else {
          navigate(`/projects/${projectId}/documents`, { replace: true });
        }
      } catch (err) {
        console.error('Error fetching project:', err);
        navigate(`/projects/${projectId}/documents`, { replace: true });
      }
    };

    redirectToMainDocument();
  }, [token, projectId, navigate]);

  return null;
};
